import CustomerHome from './CustomerHome'

export * from './CustomerHome'

export default CustomerHome
